(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosPorDependenciaModalidadTipoController', ProyectosPorDependenciaModalidadTipoController);

    ProyectosPorDependenciaModalidadTipoController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosPorDependenciaModalidadTipoController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedPeriodo = periodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        vm.centrosDocentes = centrosDocentes;
      	vm.programasEducativos = programasEducativos;
             
        sSEstatusProyecto.$promise.then(function(sSEstatusProyecto) {
        	vm.sSEstatusProyecto = sSEstatusProyecto;
        	vm.selectedssEstatusProyecto = sSEstatusProyecto[0];
        });
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosPorDependenciaModalidadTipo(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSEstatusProyecto
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();
